import { useEffect, useState } from "react";
import LoginButton from "./auth/LoginButton";
import SearchArea from "./SearchArea";

const Header = () => {
  const [pcText, setPcText] = useState(null);
  const [linkUrl, setLinkUrl] = useState(null);

  useEffect(() => {
    //コラムリンクボタンのラベル
    fetch("mapple01/mojmap/columnlabel.json")
      .then((response) => {
        return response.json();
      })
      .then((jsondata) => {
        setPcText(jsondata.str_innerhtml_pc);
        setLinkUrl(jsondata.url);
      });
  }, []);

  return (
    <div id="headerArea">
      {/* ロゴ */}
      <div className="mappleLogoArea">
        <a href="/">
          <img
            src="https://labs.mapple.com/mapple-logo.png"
            alt="mapple"
            className="mapplelogo"
          />
        </a>
      </div>

      {/* 目標物・駅・地名等検索 */}
      <SearchArea />

      <div className="OverrideBox">
        {/* コラム */}
        <a
          href={linkUrl}
          id="columnLinkButton_pc"
          className="btn btn-link"
          style={{ zIndex: 29 }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {pcText}
        </a>
        {/* ログインボタン */}
        <div
          id="MappleLoginUI"
          style={{ position: "absolute", right: "5px", zIndex: 50 }}
        >
          <LoginButton />
        </div>
      </div>
    </div>
  );
};

export default Header;
